"use strict";

define('libs/ie9.fix',['jquery'], function ($) {
  $(document).on('keydown', function (ev) {
    var target = ev.target,
      contenteditable = target.attributes.contenteditable;
    if (ev.keyCode == 8) {
      if (!target.innerHTML && contenteditable && contenteditable.value == 'true') {
        ev.preventDefault();
      }
    }
  });
});

